__turbopack_context__.v({
  "select": "Select-module__gAgpRq__select",
  "selectContainer": "Select-module__gAgpRq__selectContainer",
});
